import React from 'react';

const Services = () => {
  const servicesList = [
    'Impresión offset en cartulina o papel + laca UV, barniz o laminados',
    'La impresión en flexo con tintas a base agua',
    'Programación anual de trabajos con entregas parciales',
    'Soluciones de diseño desde el Departamento de Desarrollo',
    'Servicio personalizado a clientes en desarrollo industrial y gráfico',
    'Asesoramiento sobre diseños y materiales para envases',
    'Cartulina de 200/450g y papeles de 110/200g (puros o reciclados)'
  ];

  return (
    <section 
      id="servicios" 
      className="section services"
      style={{
        backgroundImage: 'url(/imgs/servicios-background-Sacabocado.jpg)'
      }}
    >
      <div className="services-content">
        <img 
          src="/imgs/slider-sprano-logo-transp.png" 
          alt="Soprano Gráfica" 
          className="services-logo"
        />
        <ul className="services-list">
          {servicesList.map((service, index) => (
            <li key={index}>{service}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Services;
